module.exports = "/images/arrow-black-small.svg?0742651025e743440c0c3428345bc59d";